"use strict";

$(document).ready(function () {
  if ($('body#address').length > 0) {
    selectAddress();
  }
});

function selectAddress() {
  $('.form-group .js-country').select2({
    minimumResultsForSearch: -1
  });
}